export default "__VITE_ASSET__Bcj4BW4x__$_?no-inline__"